export const DECK_SIZE = 59
export const EPIDEMIC_COUNT = 6
export const EVENT_COUNT = 5